import React from 'react';
import {connect} from "react-redux";
import {setSelectedFeature, setSelectedPartIds} from "../../../../../../../../actions/sqftResourceFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import FeatureThumbnail from "../../../../../../../visComponents/featureThumbnail";
import {getFeatureGroupName} from "../../../../../../../../misc/helpers";
import {getCurrentLayout} from "../../../../../../../appLayout";
import {HANDLE_TO_CABINETS, SHAPE_PART_ID} from "../../../../../../constants";
import PropTypes from "prop-types";

const SqftOptionsHandlesContent = (props) => {
  const {selectedPartIds, setSelectedPartIds, selectedFeature, intl, fabricatorData} = props;
  const {handlePartId} = props;

  const toggleCabinetsApplyTo = (togglePartId) => {
    let newList = [...selectedPartIds];
    newList.includes(togglePartId)
      ? newList = newList.filter(partId => partId !== togglePartId)
      : newList.push(togglePartId);
    setSelectedPartIds(newList);
  };

  const getButtonName = (partId, layout) => {
    //if (intl.locale !== "en-EN") {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        return getFeatureGroupName(featureGroup, intl, fabricatorData).replace(' Color', '')
      }
    //}
    switch (partId) {
      case "top_cabinet":
      case SHAPE_PART_ID.upper_cabinet_boxes:
        return "Upper cabinet";
      case SHAPE_PART_ID.lower_cabinet_boxes:
      case "bottom_cabinet":
        return "Lower cabinet";
      case "center_island_cabinet":
        return "Center island";
      case "vanity_cabinet":
        return "Cabinet";
      case "vanity_mirror":
        return "Mirror";
      default:
        return ""
    }
  };
  const layout = getCurrentLayout();

  return (
    <div className={"bootstrap-wrapper"}>
      <div className={"container-fluid"}>
        <div className={"row"}>
          <div className={"col-6 message-window-container_fluid"}>
            <FeatureThumbnail feature={selectedFeature.part}/>
            <div>
              <FormattedMessage id="sqft.popup.title.selectedHandle"/> {selectedFeature.part.getFeatureName()}
            </div>
          </div>
          <div className={"col-6 message-window-container_fluid"}>
            {Object.keys(HANDLE_TO_CABINETS).map(partId => {
              if (handlePartId === partId) {
                return HANDLE_TO_CABINETS[partId].map( allowedPartId => {
                  const disabledButton = false;
                  const checked = selectedPartIds.includes(allowedPartId);
                  return (
                    <div key={"dropdownRelated"+allowedPartId}
                         className={"ui-select__dropdown-list-item"}>
                      <span className={"ui-checkbox ui-checkbox--small"
                      + (!disabledButton && checked? " ui-checkbox--checked" : "")
                      + (disabledButton ? " ui-checkbox--disabled" : "")}
                            onClick={() => disabledButton ? false : toggleCabinetsApplyTo(allowedPartId)}/>
                          <span className={"ui-checkbox__label" + (disabledButton ? " ui-checkbox__label--disabled" : "")}
                                onClick={() => disabledButton ? false : toggleCabinetsApplyTo(allowedPartId)}>
                        {getButtonName(allowedPartId, layout)}
                      </span>
                    </div>
                  )
                })
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {selectedFeature, selectedPartIds} = store.sqftResourceState;
  return {
    menuOpened,
    selectedFeature,
    selectedPartIds,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  setSelectedFeature,
  setSelectedPartIds
};

SqftOptionsHandlesContent.propTypes = {
  handlePartId: PropTypes.string,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftOptionsHandlesContent)
);
